import useModalStore from '../../zustand/store/useModalStore';

import '../../css/modal.css'
import * as Icons from '../../images/icons/icons_component';
import * as Theme from '../../images/icons/icons_theme';

const HomeProfile = () => {

    // localStorage에서 원하는 계정 정보 map으로 가져오기
    const keys = ['id', 'name', 'emogdesc', 'superAdmin', 'userprjt', 'userstrm', 'admnUserMng', 'admnAuditLog', 'admnExceldownLog'];
    const localValues = Object.fromEntries( keys.map(key => [key, localStorage.getItem(key)]) );

    // my page btn state
    const setMypageModal = useModalStore((state) => state.setMypageModal);

    return (
        <div className='profile_wrapper p-5'>
            <div className='overflow-hidden justify-items-center logo_media_set'>
                <Icons.LogoIcoOpen className='object-cover' preserveAspectRatio='xMidYMid slice' />
            </div>
            <div className='profile_card'>
                <Icons.ProfileDalgu className='m-auto profile_media_set' />
                <div className='profile_text'>
                    <div>
                        <div className='profile_name'>
                            <h2 className='ho_primary'>{localValues.name}</h2>
                            <div className='h_icon_box cursor-pointer' onClick={() => setMypageModal(true)}>
                                <button className='icon' aria-label='마이페이지'><Theme.Setting className='ho_soft' /></button>
                                <div className='hover_icon'><Theme.Setting className='ho_primary' /></div>
                            </div>
                        </div>
                        <p className='co_gray'>ID {localValues.id}</p>
                    </div>
                    <div className='profile_org_wrapper'>
                        <p className='ho_primary'>소속기관</p>
                        <p className='ho_dark bold'>{localValues.emogdesc}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HomeProfile;